<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-select
        v-model="query.fState"
        style="width: 120px"
        size="small"
        clearable
      >
        <el-option value="未提交">未提交</el-option>
        <el-option value="已提交">已提交</el-option>
      </el-select>
      <el-input
        v-model="query.fBillNo"
        placeholder="单据编号"
        size="small"
        style="width: 200px"
        clearable
      />

      <el-input
        v-model="query.fDistributor"
        placeholder="经销商"
        size="small"
        style="width: 200px"
        clearable
      />

      <el-button type="primary" size="small" @click="refresh">查询</el-button>
      <el-button
        v-if="canAdd"
        type="primary"
        size="small"
        @click="_new"
      >新增</el-button>
      <el-button-export
        :url="downloadUrl"
        type="primary"
        size="small"
        style="margin: 0 10px"
      >导入模版下载</el-button-export>
      <el-button type="warning" size="small" @click="_import">导入</el-button>
      <input
        ref="fileSel"
        type="file"
        style="display: none"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      >
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
        @row-dblclick="_view"
        @select="rowSelect"
        @select-all="rowSelect"
      >
        <!-- <el-table-column type="selection" width="55" /> -->
        <el-table-column prop="fBillNo" label="单据编号" width="150" />
        <el-table-column prop="fDistributor" label="经销商" />
        <el-table-column prop="fCreateTime" label="创建日期" width="200" />
        <el-table-column prop="fState" label="状态" width="80" />
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="_view(scope.row)"
            >查看</el-button>
            <template>
              <ConfirmButton
                v-if="
                  (canDel && scope.row.fState == '审核回退') ||
                    scope.row.fState == '暂存'
                "
                @confirm="_delete(scope.row)"
              >删除</ConfirmButton>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
import ConfirmButton from '@components/ConfirmButton'
import Addfrom from './Addfrom.vue'
import FileDownload from './FileDownload'

export default {
  components: {
    ConfirmButton,
    Addfrom
  },
  data() {
    return {
      query: {
        fState: '未提交',
        fBillNo: null,
        fDistributor: null,

        pageIndex: 1,
        pageSize: 20
      },
      tableData: [],
      pageRecordTotal: 0,
      loading: false,
      canAdd: true,
      canEdit: true,
      canDel: true,
      currentEditItem: null
    }
  },
  mounted() {
    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == '010001002') {
        this.canAdd = val.isGrant
      }
      if (val.key == '010001003') {
        this.canEdit = val.isGrant
      }
      if (val.key == '010001004') {
        this.canDel = val.isGrant
      }
    })
  },
  activated() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost(
        'SalesRecordManage/SalesRecord/SalesRecordEntry',
        this.query
      )
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }
          this.tableData = res.datalist.dataEntry
          this.pageRecordTotal = res.datalist.total
        })
        .finally(() => (this.loading = false))
    },
    async _view(row) {
      var url = ''
      if (await this.billCanEdit(row.fid)) {
        url = this.$route.path + '/' + row.fid
      } else {
        url = this.$route.path + '/v/' + row.fid
      }
      this.$router.push(url)
    },
    billCanEdit: function(id) {
      return this.$httpPost('OrderManage/GetBillState', {
        fid: id,
        key: 'SalesRecord_create'
      }).then((res) => {
        if (!res.isSuccess) {
          this.$message.error(res.message)
          return false
        }
        return !res.datalist
      })
    },
    rowSelect(row) {
      console.log(row)
    },
    _new() {
      const url = this.$route.path + '/0'
      this.$router.push(url)
    },
    postData(val) {
      this.$httpPost('SalesRecordManage/SalesRecord/SalesRecordModify', {
        datalist: JSON.stringify({
          modifyType: 0,
          info: val
        })
      }).then((res) => {
        if (!res.isSuccess) {
          this.$message.error(res.message)
          return
        }
      })
    },
    _delete: function(row) {
      this.loading = true
      this.$httpPost(`SalesRecordManage/SalesRecord/DeleteSalesRecord`, {
        fid: row.fid
      }).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.$message.error(res.message)
          this.loading = false
        }
      })
    },
    downloadUrl: function() {
      return this.$buildDownloadUrl(
        'Download/SalesRecordDownload',
        {}
      )
    },
    _import: function() {
      var fileSel = this.$refs.fileSel
      fileSel.onchange = () => {
        setTimeout(() => {
          fileSel.value = null
        }, 100)
        if (!fileSel.files.length) return
        var file = fileSel.files[0]
        this.$httpPostFile('Upload/SalesRecordUpload', file).then((res) => {
          if (!res.isSuccess) {
            if (res.returnCode == '00010') {
              const h = this.$createElement
              this.$formDlg({
                title: res.message,
                readonly: true,
                formTpl: <FileDownload url={res.datalist}></FileDownload>,
                formSubmit: (formData) =>
                  this.postData(formData)
              })
            } else {
              this.$message.error(res.message)
            }
          } else {
            this.$message.success(res.message)
            this.refresh()
          }
        })
      }
      fileSel.click()
    }
  }
}
</script>
